import type { EnduserRecord } from "./EnduserCellWrapper";
import type { ReferenceField } from "./referenceFields";
import { CareTeamFieldCell } from "./CareTeamFieldCell";
import { JourneysFieldCell } from "./JourneysFieldCell";
import { CustomTypeFieldCell } from "./CustomTypeFieldCell";
import { RelationshipsFieldCell } from "./RelationshipsFieldCell";

export interface ReferenceFieldCellProps {
  field: ReferenceField;
  enduser: EnduserRecord;
}

export const ReferenceFieldCell = ({ field, enduser }: ReferenceFieldCellProps) => {
  switch (field) {
    case "assignedTo":
      return <CareTeamFieldCell assignedTo={enduser.assignedTo ?? []} />;
    case "journeys":
      return <JourneysFieldCell journeys={enduser.journeys ?? {}} />;
    case "customTypeId":
      return <CustomTypeFieldCell customTypeId={enduser.customTypeId} />;
    case "relationships":
      return <RelationshipsFieldCell relationships={enduser.relationships ?? []} />;
  }
};
